import { Button } from '@hqo/ui-atoms';
import { Plus } from 'lucide-react';
import { cn } from '@hqo/react-hooks';

interface FloatingCTAProps {
  onClick: () => void;
  dataTestId?: string;
  dataCy?: string;
  className?: string;
}

export const FloatingCTA = ({ onClick, dataTestId, dataCy, className }: FloatingCTAProps): JSX.Element => (
  <div className={cn('md:hidden fixed bottom-5 right-5 z-20', className)}>
    <Button
      size="icon"
      className="rounded-full w-14 h-14 shadow-lg hover:shadow-xl"
      onClick={onClick}
      data-testid={dataTestId ?? 'floating-cta-button'}
      data-cy={dataCy ?? 'floating-cta-button'}
    >
      <Plus className="h-6 w-6 text-white" />
    </Button>
  </div>
);
